export function Alatsi()
{
	return `
		<link rel=preconnect href="https://fonts.googleapis.com">
		<link rel=preconnect href="https://fonts.gstatic.com" crossorigin>
		<link href="https://fonts.googleapis.com/css2?family=Alatsi&display=swap" rel=stylesheet>
	`;
}
